import * as React from "react";
import { Checkbox, makeStyles } from "@fluentui/react-components";
import {
  EnrichmentField,
  FIELD_LABELS,
  FIELDS_BY_ROLE,
  AppRole,
} from "../../../../api/types";
import ColumnInput from "../../shared/ColumnInput";

export interface FieldSelectorProps {
  role: AppRole;
  selectedFields: EnrichmentField[];
  onChange: (fields: EnrichmentField[]) => void;
  fieldColumnMapping: Record<EnrichmentField, string>;
  onColumnMappingChange: (field: EnrichmentField, value: string) => void;
  startRow: number;
  endRow: number;
  disabled?: boolean;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  fieldRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
  },
});

const FieldSelector: React.FC<FieldSelectorProps> = ({
  role,
  selectedFields,
  onChange,
  fieldColumnMapping,
  onColumnMappingChange,
  startRow,
  endRow,
  disabled,
}) => {
  const styles = useStyles();
  const availableFields = [...FIELDS_BY_ROLE[role]].sort((a, b) =>
    FIELD_LABELS[a].localeCompare(FIELD_LABELS[b])
  );

  const handleToggle = (field: EnrichmentField, checked: boolean) => {
    if (checked) {
      onChange([...selectedFields, field]);
    } else {
      onChange(selectedFields.filter((f) => f !== field));
    }
  };

  return (
    <div className={styles.root}>
      {availableFields.map((field) => {
        const selected = selectedFields.includes(field);
        return (
          <div key={field} className={styles.fieldRow}>
            <Checkbox
              label={FIELD_LABELS[field]}
              checked={selected}
              onChange={(_e, data) => handleToggle(field, data.checked === true)}
              disabled={disabled}
            />
            <ColumnInput
              value={fieldColumnMapping[field] || ""}
              onChange={(value) => onColumnMappingChange(field, value)}
              startRow={startRow}
              endRow={endRow}
              disabled={disabled || !selected}
            />
          </div>
        );
      })}
    </div>
  );
};

export default FieldSelector;
